export default __webpack_public_path__ + "static/7-2ba0a39f43b56c960d845125b94daecf.jpg";